import { Directive, input } from "@angular/core";
import { Layouts } from "./se.layouts";
import { S25Util } from "../../../util/s25-util";
import { Unprefix } from "../../../pojo/Util";

@Directive()
export class LayoutWidget<T extends { META: Layouts.WidgetStatic }> {
    readonly settingValues = input.required<Record<LeafSettingIds<T["META"]>, string>>();
    readonly settings = input.required<MappedSettings<T["META"]>>();

    getPrefixedSettings<P extends string>(prefix: P): Record<Unprefix<LeafSettingIds<T["META"]>, P>, string> {
        const filtered = S25Util.entries(this.settingValues()).filter(([key]) => key.startsWith(prefix));
        const mapped = <[string, string][]>filtered.map(([key, value]) => [key.replace(prefix, ""), value]);
        return S25Util.fromEntries(mapped);
    }
}

type MappedSettings<T extends Layouts.WidgetStatic> = Layouts.MapSettings<T["settings"][number]>[];

type Depths = [never, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export type LeafSettingIds<T, D extends number = 10> = D extends 0
    ? never
    : T extends { id?: infer I extends string; settings?: infer S }
      ? S extends any[]
          ? LeafSettingIds<S[number], Depths[D]>
          : I
      : never;
